import { requestBuilder } from '../../http/RequestBuilder';

export interface SpinwheelVerifyRequest {
    spinwheelUserId: string;
    otpCode: string;
}

export interface SpinwheelVerifyResponse {
    success: boolean;
    data?: unknown; // TODO: Add actual response structure
}

export const useSpinwheelVerify = requestBuilder.mutation<
    SpinwheelVerifyResponse,
    SpinwheelVerifyRequest
>({
    endpoint: '/api/spinwheel/verify-sms',
    method: 'POST',
});
